export default {
  // Navigation
  'nav.home': 'Главная',
  'nav.products': 'Продукция',
  'nav.cuttingThickness': 'Толщина резки',
  'nav.fairs': 'Выставки',
  'nav.getQuote': 'Получить предложение',
  'nav.eCatalog': 'Электронный каталог',
  'nav.onlineOrder': 'Онлайн заказ',
  'nav.features': 'Особенности',

  // Hero Section
  'hero.badge': 'Турецкое производство • Мировые стандарты',
  'hero.title1': 'Волоконный лазер',
  'hero.title2': 'Системы резки',
  'hero.title3': 'Промышленные решения',
  'hero.description': 'Безопасные и высокопроизводительные решения для волоконной лазерной резки, разработанные AJAN LASER, подходящие для серийного производства.',
  'hero.getQuote': 'Получить предложение',
  'hero.exploreProducts': 'Изучить продукцию',

  // Products Section
  'products.title': 'Наша продукция',
  'products.subtitle': 'Комплексные решения для промышленной лазерной резки',
  'products.viewDetails': 'Подробнее',
  'products.enclosed': 'Полностью закрытый волоконный лазер',
  'products.enclosedDesc': 'Компактный дизайн и высокие стандарты безопасности',
  'products.gantry': 'Закрытый портальный волоконный лазер',
  'products.gantryDesc': 'Передовые системы для резки больших листов',
  'products.tube': 'Волоконный лазер для труб и профилей',
  'products.tubeDesc': 'Передовые системы для резки труб и профилей',

  // Application Areas
  'app.title': 'Области применения',
  'app.aluminum': 'Алюминий',
  'app.aluminumDesc': '0,5-25 мм',
  'app.carbonSteel': 'Углеродистая сталь',
  'app.carbonSteelDesc': '0,5-40 мм',
  'app.brass': 'Латунь',
  'app.brassDesc': '0,5-20 мм',
  'app.stainlessSteel': 'Нержавеющая сталь',
  'app.stainlessSteelDesc': '0,5-30 мм',
  'app.otherMetals': 'Другие металлы',
  'app.otherMetalsDesc': 'Медь, бронза, оцинкованная сталь',
  'app.materialsTitle': 'Применимые материалы',
  'app.materialsDesc1': 'С помощью станков волоконной лазерной резки AJAN LASER вы можете выполнять высокоточные операции резки различных металлических материалов.',
  'app.materialsDesc2': 'Наши станки обеспечивают превосходную производительность резки алюминия, углеродистой стали, нержавеющей стали, латуни, меди и многих других металлических материалов.',
  'app.materialsDesc3': 'Благодаря передовой технологии волоконного лазера вы можете достичь высокой скорости, точности и качества резки в промышленном производстве.',

  // Trust Section
  'trust.badge': 'Надежость и опыт',
  'trust.title': 'Более 50 лет опыта в промышленности',
  'trust.description': 'AJAN LASER является частью группы компаний AJAN, которая работает в секторе промышленного оборудования с 1973 года. Мы предоставляем надежные решения для лазерной резки клиентам по всему миру.',
  'trust.experience': 'Лет опыта',
  'trust.machines': 'Установленных станков',
  'trust.countries': 'Стран',
  'trust.laserRD': 'Лет разработки лазеров',
  'trust.leadership': 'Лидерство в отрасли',
  'trust.leadershipDesc': 'Мы являемся одним из ведущих производителей станков с ЧПУ в Турции и предоставляем решения мирового класса.',
  'trust.deepRoots': 'Глубокие корни',
  'trust.deepRootsDesc': 'Благодаря более чем 50-летнему опыту работы в отрасли мы предлагаем надежные и долговечные решения.',
  'trust.rdPeak': 'Пик исследований и разработок',
  'trust.rdPeakDesc': 'Мы постоянно инвестируем в исследования и разработки, чтобы предложить инновационные решения для лазерной резки.',

  // Certifications
  'cert.title': 'Стандарты качества и безопасности',
  'cert.description': 'Станки AJAN ЛАЗЕР производятся в полном соответствии с международными стандартами качества и безопасности. Наш приоритет — предоставлять нашим клиентам продукцию высочайшего качества и безопасности.',
  'cert.ce': 'Сертификат CE',
  'cert.ceDesc': 'Европейское соответствие',
  'cert.iso9001': 'ISO 9001',
  'cert.iso12100': 'TS EN ISO 12100',
  'cert.iso12100Desc': 'Безопасность оборудования',
  'cert.iso60204': 'TS EN 60204-1',
  'cert.iso60204Desc': 'Электрическая безопасность',
  'cert.iso60974': 'TS EN IEC 60974-1',
  'cert.iso60974Desc': 'Безопасность источника питания',
  'cert.emcLvd': 'Тесты EMC и LVD',

  // Service Section
  'service.title': 'Послепродажное обслуживание',
  'service.subtitle': 'Мы всегда с вами с нашей профессиональной командой технической поддержки',
  'service.warranty': '2 года гарантии',
  'service.warrantyDesc': 'На все наши станки предоставляется 2-летняя гарантия производителя. В течение гарантийного периода все дефекты производства устраняются бесплатно.',
  'service.exclusions': 'Исключения из гарантии',
  'service.exclusionsDesc': 'Гарантия не распространяется на расходные материалы, такие как лазерные головки, линзы, сопла, а также на повреждения, вызванные неправильным использованием.',
  'service.technicalSupport': 'Техническая поддержка',
  'service.fastService': 'Быстрое обслуживание',
  'service.spareParts': 'Запасные части',
  'service.expertTeam': 'Команда экспертов',

  // Why Choose Us
  'why.title': 'Почему AJAN LASER?',
  'why.subtitle': 'Причины выбрать нас для решений лазерной резки',
  'why.reliableTech': 'Надежная технология',
  'why.reliableTechDesc': 'Мы предлагаем долговечные и надежные решения, используя высококачественные компоненты мировых брендов.',
  'why.affordableCost': 'Доступная стоимость',
  'why.affordableCostDesc': 'Мы предлагаем конкурентоспособные цены благодаря местному производству и прямым продажам.',
  'why.continuousInnovation': 'Постоянные инновации',
  'why.continuousInnovationDesc': 'Мы постоянно совершенствуем наши продукты с помощью исследований и разработок.',
  'why.customerFocused': 'Ориентация на клиента',
  'why.customerFocusedDesc': 'Мы предоставляем индивидуальные решения и быструю техническую поддержку.',

  // Features
  'features.speedDesc': 'Высокая скорость резки и точность',
  'features.domesticProduction': 'Местное производство',
  'features.domesticProductionDesc': 'Турецкое производство и качество',
  'features.serviceNetwork': 'Сеть обслуживания',
  'features.serviceNetworkDesc': 'Быстрая техническая поддержка',
  'features.easyToUse': 'Простота использования',
  'features.easyToUseDesc': 'Удобный интерфейс',

  // CTA Section
  'cta.title': 'Готовы начать?',
  'cta.subtitle': 'Свяжитесь с нами для получения подробной информации о наших решениях для лазерной резки',
  'cta.callNow': 'Позвонить сейчас',
  'cta.viewCatalogs': 'Просмотреть каталоги',

  // Contact Form
  'form.title': 'Получить предложение',
  'form.subtitle': 'Заполните форму, и мы свяжемся с вами в ближайшее время',
  'form.companyName': 'Название компании',
  'form.companyNamePlaceholder': 'Введите название компании',
  'form.fullName': 'Полное имя',
  'form.fullNamePlaceholder': 'Введите ваше имя',
  'form.email': 'Электронная почта',
  'form.emailPlaceholder': 'Введите ваш email',
  'form.phone': 'Телефон',
  'form.phonePlaceholder': 'Введите ваш телефон',
  'form.address': 'Адрес',
  'form.addressPlaceholder': 'Введите ваш адрес',
  'form.message': 'Сообщение',
  'form.messagePlaceholder': 'Введите ваше сообщение',
  'form.characters': 'символов',
  'form.submit': 'Отправить',
  'form.submitting': 'Отправка...',
  'form.success': 'Ваше сообщение успешно отправлено!',
  'form.error': 'Произошла ошибка. Пожалуйста, попробуйте еще раз.',

  // Footer
  'footer.description': 'Высокопроизводительные системы волоконной лазерной резки для современного производства.',
  'footer.quickLinks': 'Быстрые ссылки',
  'footer.home': 'Главная',
  'footer.catalog': 'Каталог',
  'footer.fairs': 'Выставки',
  'footer.cuttingThickness': 'Толщина резки',
  'footer.contact': 'Контакты',
  'footer.phone': 'Телефон:',
  'footer.fax': 'Факс:',
  'footer.email': 'Email:',
  'footer.address': 'Адрес:',
  'footer.factory': 'Завод:',
  'footer.customerService': 'Служба поддержки:',
  'footer.certifications': 'Сертификаты',
  'footer.ceCertificate': 'Сертификат CE',
  'footer.iso9001': 'ISO 9001',
  'footer.emcLvdTests': 'Тесты EMC и LVD',
  'footer.tsEnIso12100': 'TS EN ISO 12100',
  'footer.rights': '© 2025 AJAN ЛАЗЕР. Все права защищены.',
  'footer.websiteBuilder': 'Website Builder',

  // Specs
  'specs.laserPower': 'Мощность лазера',
  'specs.zAxisHeight': 'Высота оси Z',
  'specs.xyPositionAccuracy': 'Точность позиционирования XY',
  'specs.xyRepeatAccuracy': 'Повторяемость XY',
  'specs.xyMaxSpeed': 'Макс. скорость XY',
  'specs.xyMaxSpeedValue': 'До 150 м/мин',
  'specs.xyMaxSpeedIdle': 'Макс. скорость XY (холостой ход)',
  'specs.xyMaxSpeedIdleValue': 'До 100 м/мин',
  'specs.xyMaxAcceleration': 'Макс. ускорение XY',
  'specs.laserSource': 'Источник лазера',
  'specs.laserHead': 'Лазерная головка',
  'specs.body': 'Корпус',
  'specs.bodyValue': 'Сварная стальная конструкция',
  'specs.xyRail': 'Направляющие XY',
  'specs.xyRack': 'Зубчатая рейка XY',
  'specs.xyRackValue': 'Закаленная и шлифованная',
  'specs.servoMotors': 'Серводвигатели',
  'specs.reducer': 'Редуктор',
  'specs.electricalComponents': 'Электрические компоненты',
  'specs.lubricationSystem': 'Система смазки',
  'specs.lubricationSystemValue': 'Автоматическая централизованная',
  'specs.chiller': 'Чиллер',
  'specs.pneumaticComponents': 'Пневматические компоненты',
  'specs.cncControl': 'ЧПУ управление',

  // Fairs
  'fairs.title': 'Выставки',
  'fairs.subtitle': 'Мы встречаемся с вами на ведущих выставках отрасли',
  'fairs.upcoming': 'Предстоящие выставки',
  'fairs.upcomingDesc': 'Посетите наш стенд на предстоящих выставках',
  'fairs.past': 'Прошедшие выставки',
  'fairs.pastDesc': 'Выставки, в которых мы участвовали',
  'fairs.details': 'Подробнее',
  'fairs.noUpcoming': 'В настоящее время нет запланированных выставок',
  'fairs.noPast': 'Нет прошедших выставок',
  'fairs.ctaTitle': 'Хотите встретиться на выставке?',
  'fairs.ctaSubtitle': 'Позвоните нам, чтобы договориться о встрече',
  'fairs.callForAppointment': 'Позвонить для встречи',
};
